import { Component, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { DeviceService } from '../../../device.service';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ColumnsConfig, TableConfig, TableData } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-im-peak-power',
	templateUrl: './im-peak-power.component.html',
	styleUrls: []
})
export class ImPeakPowerComponent {

	@ViewChild("popupModal") popupModal: ModalComponent;
	@Input() device: any = {};

	maxDate = new Date((new Date()).getTime() - 24 * 60 * 60 * 1000); // yesterday
	toDate = this.maxDate; // yesterday
	fromDate = new Date((new Date()).getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
	minDate = this.fromDate;

	getDailyDetails: Subscription = new Subscription();

	chartsData = [];
	chartObject = {
		config:  {
			legend: 'none',
			bar: {
				groupWidth: 30
			},
		},
		columnNames: ['Time', 'Value'],
		hasData: false
	}

	peakPowerChartData = [];
	peakPowerExport: any = [];

	tableData: TableData[] = [];
	tableConfig: TableConfig = {
		tableHeight: 150,
	};
	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		time: TimeSource.PcTime,
	};

	columnConfig: ColumnsConfig[] = [
		{ key: 'event_id', name: this.translate.instant('events.sequence_id'), type: "link", hasFilter: false},
		{ key: 'time', name: this.translate.instant('g.time'), type: "date", hasFilter: false },
	];
	
	customerID: number = 0;

	constructor(
		private deviceService: DeviceService,
		private commonService: CommonService,
		private translate: TranslateService,
		private route: ActivatedRoute,
	) {}

	ngOnInit() {
		this.commonService.applyTimeSourceTooltips(this.columnConfig, this.timeSourceByColumn);

		if (this.device?.config_info?.installation_date)
			this.minDate = moment.utc(this.device.config_info.installation_date * 1000).startOf('day').toDate();

		this.customerID = this.route.parent.snapshot.params.customerId || 0;
	}

	ngOnChanges(changes) {
		if(changes.device && this.device)
			this.getPeakPower();
	}

	changeDate(field, value) {
		this[field] = value;
		this.getPeakPower();
	}

	getPeakPower() {
		const zoneDiff	= new Date().getTimezoneOffset() * -1;
		let fromDate:any	= new Date(new Date(this.fromDate).getTime() + (zoneDiff * 60 * 1000));
		let toDate:any = new Date(new Date(this.toDate).getTime() + (zoneDiff * 60 * 1000));
		fromDate = moment(fromDate).utc().startOf('day').unix();
		toDate = moment(toDate).utc().endOf('day').unix();

		this.peakPowerChartData = [];
		this.chartsData = [];
		this.peakPowerExport = [];

		const options = { checkConnectivityAfterShippingDate: true };
		this.getDailyDetails = this.deviceService.getDailyDetails(this.device.mac_address, fromDate, toDate, options).subscribe((data: any) => {
			for (const dayUnix in data) {
				const dayData = data[dayUnix] || {};

				const day = moment.utc(+dayUnix * 1000).format('l');
				const val = dayData.negative_peak_power || 0;

				this.chartsData.push([day, val]);

				if (dayData.negative_peak_power_data?.time)
					dayData.negative_peak_power_data.time = this.commonService.getUnixTimezoneByLocaltime(dayData.negative_peak_power_data.time);

				this.peakPowerChartData.push(dayData.negative_peak_power_data || {});

				if (Object.keys(dayData).length)
					this.peakPowerExport.push([day, val]);

			}
		});
	}

	onPeakPowerDataClick(event: any) {
		if (!event || !('row' in event))
			return;
		
		this.tableData = [];
		const groupIndex = event.row;
		const targetEvent = this.peakPowerChartData[groupIndex] || null;

		this.tableData = [
			{
				event_id: { value: targetEvent.event_id, link: ['/', this.customerID, this.device.config_info.site_id, this.device.mac_address, 'events'] },
				time: { value: moment(targetEvent.time*1000).format('MM/DD/YYYY hh:mm:ss A') },
			}
		];

		this.popupModal.show();
	}

	exportPeakPower() {
		const columnNames = [
			this.translate.instant('g.date'),
			this.translate.instant('g.value')
		];
		const fileName = this.translate.instant('iotemeter.performance_analytics.peak_power');
		this.commonService.exportToCsv(columnNames, this.peakPowerExport, fileName);
	}

	ngOnDestroy() {
		this.getDailyDetails?.unsubscribe();
		this.popupModal?.hide();
	}
}
